import { useAction } from "@/hooks/shared";
import { disableCompanyHandler } from "@/services";

export const useDisableCompany = () => useAction(disableCompanyHandler);
